import "../icon.styles.css";

const CSSIcon = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 250 250"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g id="Frame 1">
        <path
          className="highlight"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M177.548 180.088L184.192 52.6713H123.49L124.396 21.5511H214.392L199.292 207.686L124.396 228.236V196.529L177.548 180.088Z"
          fill="#DEF7FF"
        />
        <path
          className="shadow"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.448 1H237.948L218.016 221.777L124.396 248.2L31.984 221.777L11.448 1ZM124.396 196.529L71.848 180.088L69.432 144.27H97.216V159.537L124.396 168.932L151.576 159.537L154.596 130.766H94.8V104.343H154.596L157.616 79.6812H65.808L62.788 52.6713H123.49L124.396 21.5511H214.392L199.292 207.686L124.396 228.236V196.529Z"
          fill="#B9CCD2"
        />
      </g>
    </svg>
  );
};

export default CSSIcon;
